import { PanoViewer } from '@egjs/view360';

export class PanoviewerOperations {
  constructPanoviewer (container, yaw, pitch, fov, gyroMode, useZoom) {
    return new PanoViewer(container, {
      yaw: yaw,
      pitch: pitch,
      fov: fov,
      useKeyboard: false,
      gyroMode: gyroMode,
      useZoom: useZoom
    });
  }
}
